import { Tabs, TabsProps } from 'antd'
import BaseAutocomplete from 'components/common/BaseAutocomplete'
import BaseDocumentCard from 'components/common/BaseDocument/BaseDocumentCard'
import IconQuarter from 'components/icons/IconQuarter'
import { API_KEY } from 'constants/react-query'
import useNotification from 'hooks/useNotification'
import useTableParams from 'hooks/useTableParams'
import { ISelectOption } from 'models/common'
import { IDocument } from 'models/document'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getDepartmentList } from 'services/department.service'
import { getDocumentList } from 'services/document.service'
import { useAppSelector } from 'store'
import { getAuthFromStore } from 'store/slices/auth'

function Documents() {
  const { tableParams, searchParams } = useTableParams<IDocument>()
  const { t } = useTranslation()
  const { slug } = useParams()
  const n = useNotification()
  const [quarter, setQuarter] = useState<number>(1)
  const infoAccount = useAppSelector(getAuthFromStore)
  const [options, setOptions] = useState<ISelectOption[]>([])

  const [search, setSearch] = useState<ISelectOption[]>([
    {
      label: t('admin.staff.all_department'),
      value: ''
    }
  ])
  const onChange = (key: string) => {
    setQuarter(+key)
  }

  useQuery({
    queryFn: async () => {
      const res = await getDepartmentList({ clientId: slug })
      const options: ISelectOption[] = res.items.reduce((acc: ISelectOption[], cur: any) => {
        acc.push({
          value: cur.id,
          label: cur.name
        })
        return acc
      }, [])
      setSearch([options?.[0]])
      setOptions(options)
    },
    onError: n.handleUseQueryError(),
    staleTime: 0
  })

  const { data } = useQuery({
    queryKey: [API_KEY.SUPPORTING_DOCUMENT, search?.[0]?.value],
    queryFn: async () => await getDocumentList({ ...searchParams, departmentId: search?.[0].value as number })
  })

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: t('admin.department_detail.quarter') + ' ' + 1,
      className: 'center',
      icon: <IconQuarter />,
      children: <BaseDocumentCard data={data} role={infoAccount.role} quarter={1} />
    },
    {
      key: '2',
      label: t('admin.department_detail.quarter') + ' ' + 2,
      className: 'center',
      icon: <IconQuarter />,
      children: <BaseDocumentCard data={data} role={infoAccount.role} quarter={2} />
    },
    {
      key: '3',
      label: t('admin.department_detail.quarter') + ' ' + 3,
      className: 'center',
      icon: <IconQuarter />,
      children: <BaseDocumentCard data={data} role={infoAccount.role} quarter={3} />
    },
    {
      key: '4',
      label: t('admin.department_detail.quarter') + ' ' + 4,
      className: 'center',
      icon: <IconQuarter />,
      children: <BaseDocumentCard data={data} role={infoAccount.role} quarter={4} />
    }
  ]

  return (
    <div>
      <BaseAutocomplete
        className={'w-56 mb-6'}
        defaultValue={[search?.[0]] as ISelectOption[]}
        onChange={(option) => {
          setSearch([option])
        }}
        name={''}
        listOption={options}
      />

      <Tabs defaultActiveKey='1' items={items} onChange={onChange} />
    </div>
  )
}
export default Documents
